"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyListingsResponse$ = exports.PropertyListingsResponse$outboundSchema = exports.PropertyListingsResponse$inboundSchema = void 0;
exports.propertyListingsResponseToJSON = propertyListingsResponseToJSON;
exports.propertyListingsResponseFromJSON = propertyListingsResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertylistingwrapper_js_1 = require("./propertylistingwrapper.js");
/** @internal */
exports.PropertyListingsResponse$inboundSchema = z.object({
    data: z.array(propertylistingwrapper_js_1.PropertyListingWrapper$inboundSchema),
});
/** @internal */
exports.PropertyListingsResponse$outboundSchema = z.object({
    data: z.array(propertylistingwrapper_js_1.PropertyListingWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyListingsResponse$;
(function (PropertyListingsResponse$) {
    /** @deprecated use `PropertyListingsResponse$inboundSchema` instead. */
    PropertyListingsResponse$.inboundSchema = exports.PropertyListingsResponse$inboundSchema;
    /** @deprecated use `PropertyListingsResponse$outboundSchema` instead. */
    PropertyListingsResponse$.outboundSchema = exports.PropertyListingsResponse$outboundSchema;
})(PropertyListingsResponse$ || (exports.PropertyListingsResponse$ = PropertyListingsResponse$ = {}));
function propertyListingsResponseToJSON(propertyListingsResponse) {
    return JSON.stringify(exports.PropertyListingsResponse$outboundSchema.parse(propertyListingsResponse));
}
function propertyListingsResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyListingsResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyListingsResponse' from JSON`);
}
//# sourceMappingURL=propertylistingsresponse.js.map